export default {
  data() {
    const catalogSectionsPanelInCreation = [
      {
        id: 'images',
        name: 'Images',
      },
      {
        id: 'pricing',
        name: 'Pricing',
      },
      {
        id: 'variants',
        name: 'Variants',
      },
      {
        id: 'ads',
        name: 'Ads',
      },
    ];
    const catalogSectionsPanel = [
      ...catalogSectionsPanelInCreation,
      {
        id: 'reviews',
        name: 'Reviews',
      },
      {
        id: 'pixels',
        name: 'Pixels',
      },
    ];
    return {
      hurryBoxSectionsPanel: [],
      descriptionSectionsPanel: [],
      orderPolicySectionsPanel: [],
      orderDescriptionSectionsPanel: [],
      catalogSectionsPanel,
      catalogSectionsPanelInCreation,
      descriptionObserver: null,
      sectionDescriptionObserver: null,
      hurryBoxObserver: null,
      orderPolicyObserver: null,
      orderDescriptionObserver: null,
      isWrapperPanelVisible: false,
      isSectionsExpanded: false,
      isHurryBoxSectionsExpanded: true,
      isOrderPolicySectionsExpanded: true,
      isOrderDescriptionSectionsExpanded: true,
      activeSectionId: null,
      isCatalogCreation: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initIntersectionObserver();
      this.initSectionObserver(this.descriptionSectionsPanel);
      this.initHurryBoxIntersectionObserver();
      this.initOrderPolicyIntersectionObserver();
    });
  },
  beforeDestroy() {
    if (this.descriptionObserver) {
      this.descriptionObserver.disconnect();
    }
    if (this.sectionDescriptionObserver) {
      this.sectionDescriptionObserver.disconnect();
    }
    if (this.hurryBoxObserver) {
      this.hurryBoxObserver.disconnect();
    }
    if (this.orderPolicyObserver) {
      this.orderPolicyObserver.disconnect();
    }
    if (this.orderDescriptionObserver) {
      this.orderDescriptionObserver.disconnect();
    }
  },
  methods: {
    toggleSections() {
      this.isSectionsExpanded = !this.isSectionsExpanded;
    },
    toggleHurryBoxSections() {
      this.isHurryBoxSectionsExpanded = !this.isHurryBoxSectionsExpanded;
    },
    toggleOrderPolicySections() {
      this.isOrderPolicySectionsExpanded = !this.isOrderPolicySectionsExpanded;
    },
    toggleOrderDescriptionSections() {
      this.isOrderDescriptionSectionsExpanded = !this.isOrderDescriptionSectionsExpanded;
    },
    initIntersectionObserver() {
      const options = {
        root: null,
        threshold: [0],
        // rootMargin: '0px 0px 100px 0px',
      };
      this.descriptionObserver = new IntersectionObserver(this.handleDescriptionIntersect, options);
      const descriptionSection = this.$refs.descriptionSection;
      if (descriptionSection) {
        this.descriptionObserver.observe(descriptionSection);
      }
    },
    initHurryBoxIntersectionObserver() {
      const options = {
        root: null,
        threshold: [0],
        // rootMargin: '0px 0px 100px 0px',
      };
      this.hurryBoxObserver = new IntersectionObserver(this.handleHurryBoxIntersect, options);
      const hurryBoxSection = this.$refs.hurryBoxSection;
      if (hurryBoxSection) {
        this.hurryBoxObserver.observe(hurryBoxSection);
      }
    },
    initOrderPolicyIntersectionObserver() {
      const options = {
        root: null,
        threshold: [0],
        // rootMargin: '0px 0px 100px 0px',
      };
      this.orderPolicyObserver = new IntersectionObserver(this.handleOrderPolicyIntersect, options);
      const orderPolicySection = this.$refs.orderPolicySection;
      if (orderPolicySection) {
        this.orderPolicyObserver.observe(orderPolicySection);
      }
    },
    initOrderDescriptionIntersectionObserver() {
      const options = {
        root: null,
        threshold: [0],
        // rootMargin: '0px 0px 100px 0px',
      };
      this.orderDescriptionObserver = new IntersectionObserver(this.handleOrderPolicyIntersect, options);
      const orderDescriptionSection = this.$refs.orderDescriptionSection;
      if (orderDescriptionSection) {
        this.orderDescriptionObserver.observe(orderDescriptionSection);
      }
    },
    initSectionObserver(descriptionSectionsPanel) {
      if (!descriptionSectionsPanel || descriptionSectionsPanel.length === 0) return;
      const options = {
        root: null,
        threshold: [0, 0.5, 0.9],
        rootMargin: '-10% 0px -20% 0px',
      };
      this.sectionDescriptionObserver = new IntersectionObserver(this.handleSectionIntersect, options);
      descriptionSectionsPanel.forEach(section => {
        const element = document.getElementById(section.id);
        if (element) {
          this.sectionDescriptionObserver.observe(element);
        }
      });
    },
    handleDescriptionIntersect(entries) {
      entries.forEach(entry => {
        this.isWrapperPanelVisible = entry.isIntersecting;
        this.isSectionsExpanded = entry.isIntersecting;
        // if (!entry.isIntersecting) {
        //   this.isSectionsExpanded = false
        // }
      });
    },
    handleHurryBoxIntersect(entries) {
      entries.forEach(entry => {
        this.isWrapperPanelVisible = entry.isIntersecting;
        this.isHurryBoxSectionsExpanded = entry.isIntersecting;
      });
    },
    handleOrderPolicyIntersect(entries) {
      entries.forEach(entry => {
        this.isWrapperPanelVisible = entry.isIntersecting;
        this.isOrderPolicySectionsExpanded = entry.isIntersecting;
      });
    },
    handleOrderDescriptionIntersect(entries) {
      entries.forEach(entry => {
        this.isWrapperPanelVisible = entry.isIntersecting;
        this.isOrderDescriptionSectionsExpanded = entry.isIntersecting;
      });
    },
    handleSectionIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          this.activeSectionId = entry.target.id;
        }
      });
    },
    onUpdateSectionsPanel(sections) {
      this.descriptionSectionsPanel = sections;
      this.$nextTick(() => {
        this.initSectionObserver(sections);
      });
    },
    onUpdateHurryBoxSectionsPanel(sections) {
      this.hurryBoxSectionsPanel = sections;
    },
    onUpdateOrderPolicySectionsPanel(sections) {
      this.orderPolicySectionsPanel = sections;
    },
    onUpdateOrderDescriptionSectionsPanel(sections) {
      this.orderDescriptionSectionsPanel = sections;
    },
    scrollToSection(sectionId, defaultOffset = 100) {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.offsetTop + defaultOffset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }
    },
  },
  watch: {
    descriptionSectionsPanel: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length && (!oldVal || oldVal.length === 0)) {
          this.$nextTick(() => {
            this.initIntersectionObserver();
            this.initSectionObserver(newVal);
          });
        }
      },
      immediate: true,
    },
  },
};
